import { createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, vModelSelect as _vModelSelect, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3d7ee31f")

_pushScopeId("data-v-3d7ee31f")
const _hoisted_1 = {
  class: "container",
  style: {"padding-top":"30px"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-12" }
const _hoisted_4 = {
  id: "add-listing",
  class: "separated-form"
}
const _hoisted_5 = { class: "add-listing-section" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "add-listing-headline" }, [
  /*#__PURE__*/_createVNode("h3", null, [
    /*#__PURE__*/_createVNode("i", { class: "sl sl-icon-doc" }),
    /*#__PURE__*/_createTextVNode(" Basic Information")
  ])
], -1)
const _hoisted_7 = { class: "row with-forms" }
const _hoisted_8 = { class: "col-md-12" }
const _hoisted_9 = /*#__PURE__*/_createVNode("h5", null, [
  /*#__PURE__*/_createTextVNode("Restaurant name "),
  /*#__PURE__*/_createVNode("i", {
    class: "tip",
    title: "Name of your business"
  })
], -1)
const _hoisted_10 = { class: "row with-forms" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createVNode("h5", null, "Category"),
  /*#__PURE__*/_createVNode("select", { class: "chosen-select-no-single" }, [
    /*#__PURE__*/_createVNode("option", {
      disabled: "",
      selected: "",
      value: "",
      label: "Select Category"
    }, "Select Category"),
    /*#__PURE__*/_createVNode("option", null, "Restaurant"),
    /*#__PURE__*/_createVNode("option", null, "Bar")
  ])
], -1)
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = /*#__PURE__*/_createVNode("h5", null, "Tags", -1)
const _hoisted_14 = { class: "add-listing-section margin-top-45" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "add-listing-headline" }, [
  /*#__PURE__*/_createVNode("h3", null, [
    /*#__PURE__*/_createVNode("i", { class: "sl sl-icon-location" }),
    /*#__PURE__*/_createTextVNode(" Location")
  ])
], -1)
const _hoisted_16 = { class: "submit-section" }
const _hoisted_17 = { class: "row with-forms" }
const _hoisted_18 = { class: "col-md-6" }
const _hoisted_19 = /*#__PURE__*/_createVNode("h5", null, "City", -1)
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<option disabled selected value label=\"Select City\" data-v-3d7ee31f>Select City</option><option data-v-3d7ee31f>Luxembourg</option><option data-v-3d7ee31f>Diekirch</option><option data-v-3d7ee31f>Differdange</option><option data-v-3d7ee31f>Dudelange</option><option data-v-3d7ee31f>Echternach</option><option data-v-3d7ee31f>Esch-sur-Alzette</option><option data-v-3d7ee31f>Ettelbruck</option><option data-v-3d7ee31f>Remich</option><option data-v-3d7ee31f>Rumelange</option><option data-v-3d7ee31f>Vianden</option><option data-v-3d7ee31f>Wiltz</option>", 12)
const _hoisted_32 = { class: "col-md-6" }
const _hoisted_33 = /*#__PURE__*/_createVNode("h5", null, "Zip-Code", -1)
const _hoisted_34 = { class: "col-md-6" }
const _hoisted_35 = /*#__PURE__*/_createVNode("h5", null, "Address", -1)
const _hoisted_36 = { class: "col-md-6" }
const _hoisted_37 = /*#__PURE__*/_createVNode("h5", null, "Address 2", -1)
const _hoisted_38 = { class: "add-listing-section margin-top-45" }
const _hoisted_39 = /*#__PURE__*/_createVNode("div", { class: "add-listing-headline" }, [
  /*#__PURE__*/_createVNode("h3", null, [
    /*#__PURE__*/_createVNode("i", { class: "sl sl-icon-docs" }),
    /*#__PURE__*/_createTextVNode(" Details")
  ])
], -1)
const _hoisted_40 = { class: "form" }
const _hoisted_41 = /*#__PURE__*/_createVNode("h5", null, "Description", -1)
const _hoisted_42 = { class: "row with-forms" }
const _hoisted_43 = { class: "col-md-4" }
const _hoisted_44 = /*#__PURE__*/_createVNode("h5", null, "Phone", -1)
const _hoisted_45 = /*#__PURE__*/_createVNode("div", { class: "col-md-4" }, [
  /*#__PURE__*/_createVNode("h5", null, [
    /*#__PURE__*/_createTextVNode("Website "),
    /*#__PURE__*/_createVNode("span", null, "(optional)")
  ]),
  /*#__PURE__*/_createVNode("input", { type: "text" })
], -1)
const _hoisted_46 = { class: "col-md-4" }
const _hoisted_47 = /*#__PURE__*/_createVNode("h5", null, "E-mail", -1)
const _hoisted_48 = /*#__PURE__*/_createStaticVNode("<div class=\"row with-forms\" data-v-3d7ee31f><div class=\"col-md-4\" data-v-3d7ee31f><h5 class=\"fb-input\" data-v-3d7ee31f><i class=\"fa fa-facebook-square\" data-v-3d7ee31f></i> Facebook <span data-v-3d7ee31f>(optional)</span></h5><input type=\"text\" placeholder=\"https://www.facebook.com/\" data-v-3d7ee31f></div><div class=\"col-md-4\" data-v-3d7ee31f><h5 data-v-3d7ee31f><i class=\"fa fa-instagram\" data-v-3d7ee31f></i> Instagram <span data-v-3d7ee31f>(optional)</span></h5><input type=\"text\" placeholder=\"https://www.instagram.com/\" data-v-3d7ee31f></div><div class=\"col-md-4\" data-v-3d7ee31f><h5 class=\"twitter-input\" data-v-3d7ee31f><i class=\"fa fa-twitter\" data-v-3d7ee31f></i> Twitter <span data-v-3d7ee31f>(optional)</span></h5><input type=\"text\" placeholder=\"https://www.twitter.com/\" data-v-3d7ee31f></div></div>", 1)
const _hoisted_49 = { class: "add-listing-section margin-top-45" }
const _hoisted_50 = /*#__PURE__*/_createVNode("div", { class: "add-listing-headline" }, [
  /*#__PURE__*/_createVNode("h3", null, [
    /*#__PURE__*/_createVNode("i", { class: "sl sl-icon-clock" }),
    /*#__PURE__*/_createTextVNode(" Opening Hours")
  ])
], -1)
const _hoisted_51 = { class: "row with-forms" }
const _hoisted_52 = { class: "col-md-4" }
const _hoisted_53 = /*#__PURE__*/_createVNode("h5", null, "Timeslot duration", -1)
const _hoisted_54 = /*#__PURE__*/_createStaticVNode("<option disabled selected value label=\"Select timeslot duration\" data-v-3d7ee31f>Select timeslot duration</option><option value=\"1800\" data-v-3d7ee31f>0.5h</option><option value=\"3600\" data-v-3d7ee31f>1h</option><option value=\"5400\" data-v-3d7ee31f>1.5h</option><option value=\"7200\" data-v-3d7ee31f>2h</option>", 5)
const _hoisted_59 = { class: "col-md-4" }
const _hoisted_60 = /*#__PURE__*/_createVNode("h5", null, "Number of seats inside", -1)
const _hoisted_61 = { class: "col-md-4" }
const _hoisted_62 = /*#__PURE__*/_createVNode("h5", null, "Number of seats outside", -1)
const _hoisted_63 = { class: "add-listing-section margin-top-45" }
const _hoisted_64 = /*#__PURE__*/_createVNode("div", { class: "add-listing-headline" }, [
  /*#__PURE__*/_createVNode("h3", null, [
    /*#__PURE__*/_createVNode("i", { class: "sl sl-icon-picture" }),
    /*#__PURE__*/_createTextVNode(" Images")
  ])
], -1)
const _hoisted_65 = { class: "row with-forms" }
const _hoisted_66 = /*#__PURE__*/_createTextVNode("Add ")
const _hoisted_67 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-circle-right" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Multiselect = _resolveComponent("Multiselect")
  const _component_OpeningHoursSelect = _resolveComponent("OpeningHoursSelect")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _hoisted_9,
                _withDirectives(_createVNode("input", {
                  class: "search-field",
                  type: "text",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.newPlace.name = $event))
                }, null, 512), [
                  [_vModelText, _ctx.newPlace.name]
                ])
              ])
            ]),
            _createVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode("div", _hoisted_12, [
                _hoisted_13,
                _createVNode(_component_Multiselect, {
                  modelValue: _ctx.newPlace.tagIds,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.newPlace.tagIds = $event)),
                  mode: "tags",
                  options: _ctx.availableTags,
                  searchable: true
                }, null, 8, ["modelValue", "options"])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_14, [
            _hoisted_15,
            _createVNode("div", _hoisted_16, [
              _createVNode("div", _hoisted_17, [
                _createVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _withDirectives(_createVNode("select", {
                    class: "chosen-select-no-single",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.newPlace.address.city = $event))
                  }, [
                    _hoisted_20
                  ], 512), [
                    [_vModelSelect, _ctx.newPlace.address.city]
                  ])
                ]),
                _createVNode("div", _hoisted_32, [
                  _hoisted_33,
                  _withDirectives(_createVNode("input", {
                    type: "text",
                    placeholder: "e.g. L-1520",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.newPlace.address.postCode = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.newPlace.address.postCode]
                  ])
                ]),
                _createVNode("div", _hoisted_34, [
                  _hoisted_35,
                  _withDirectives(_createVNode("input", {
                    type: "text",
                    placeholder: "e.g. 964 School Street",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.newPlace.address.addressLine1 = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.newPlace.address.addressLine1]
                  ])
                ]),
                _createVNode("div", _hoisted_36, [
                  _hoisted_37,
                  _withDirectives(_createVNode("input", {
                    type: "text",
                    placeholder: "additional information",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.newPlace.address.addressLine2 = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.newPlace.address.addressLine2]
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_38, [
            _hoisted_39,
            _createVNode("div", _hoisted_40, [
              _hoisted_41,
              _withDirectives(_createVNode("textarea", {
                class: "WYSIWYG",
                name: "summary",
                cols: "40",
                rows: "3",
                id: "summary",
                spellcheck: "true",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.newPlace.description = $event))
              }, null, 512), [
                [_vModelText, _ctx.newPlace.description]
              ])
            ]),
            _createVNode("div", _hoisted_42, [
              _createVNode("div", _hoisted_43, [
                _hoisted_44,
                _withDirectives(_createVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.newPlace.phoneNumber = $event))
                }, null, 512), [
                  [_vModelText, _ctx.newPlace.phoneNumber]
                ])
              ]),
              _hoisted_45,
              _createVNode("div", _hoisted_46, [
                _hoisted_47,
                _withDirectives(_createVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.newPlace.email = $event))
                }, null, 512), [
                  [_vModelText, _ctx.newPlace.email]
                ])
              ])
            ]),
            _hoisted_48
          ]),
          _createVNode("div", _hoisted_49, [
            _hoisted_50,
            _createVNode("div", _hoisted_51, [
              _createVNode("div", _hoisted_52, [
                _hoisted_53,
                _withDirectives(_createVNode("select", {
                  class: "chosen-select-no-single",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.newPlace.timeslotDurationSeconds = $event))
                }, [
                  _hoisted_54
                ], 512), [
                  [_vModelSelect, _ctx.newPlace.timeslotDurationSeconds]
                ])
              ]),
              _createVNode("div", _hoisted_59, [
                _hoisted_60,
                _withDirectives(_createVNode("input", {
                  type: "number",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.newPlace.timeslotDefaultSeatsInside = $event))
                }, null, 512), [
                  [_vModelText, _ctx.newPlace.timeslotDefaultSeatsInside]
                ])
              ]),
              _createVNode("div", _hoisted_61, [
                _hoisted_62,
                _withDirectives(_createVNode("input", {
                  type: "number",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.newPlace.timeslotDefaultSeatsOutside = $event))
                }, null, 512), [
                  [_vModelText, _ctx.newPlace.timeslotDefaultSeatsOutside]
                ])
              ])
            ]),
            _createVNode("div", null, [
              _createVNode(_component_OpeningHoursSelect, {
                day: 'Monday',
                openingHour: _ctx.newPlace.openingHour,
                "onUpdate:openingHour": [
                  _cache[13] || (_cache[13] = ($event: any) => (_ctx.newPlace.openingHour = $event)),
                  _ctx.updateOpeningHour
                ],
                closingHour: _ctx.newPlace.closingHour,
                "onUpdate:closingHour": [
                  _cache[14] || (_cache[14] = ($event: any) => (_ctx.newPlace.closingHour = $event)),
                  _ctx.updateClosingHour
                ]
              }, null, 8, ["openingHour", "closingHour", "onUpdate:openingHour", "onUpdate:closingHour"]),
              _createVNode(_component_OpeningHoursSelect, {
                day: 'Tuesday',
                openingHour: _ctx.newPlace.openingHour,
                "onUpdate:openingHour": [
                  _cache[15] || (_cache[15] = ($event: any) => (_ctx.newPlace.openingHour = $event)),
                  _ctx.updateOpeningHour
                ],
                closingHour: _ctx.newPlace.closingHour,
                "onUpdate:closingHour": [
                  _cache[16] || (_cache[16] = ($event: any) => (_ctx.newPlace.closingHour = $event)),
                  _ctx.updateClosingHour
                ]
              }, null, 8, ["openingHour", "closingHour", "onUpdate:openingHour", "onUpdate:closingHour"]),
              _createVNode(_component_OpeningHoursSelect, {
                day: 'Wednesday',
                openingHour: _ctx.newPlace.openingHour,
                "onUpdate:openingHour": [
                  _cache[17] || (_cache[17] = ($event: any) => (_ctx.newPlace.openingHour = $event)),
                  _ctx.updateOpeningHour
                ],
                closingHour: _ctx.newPlace.closingHour,
                "onUpdate:closingHour": [
                  _cache[18] || (_cache[18] = ($event: any) => (_ctx.newPlace.closingHour = $event)),
                  _ctx.updateClosingHour
                ]
              }, null, 8, ["openingHour", "closingHour", "onUpdate:openingHour", "onUpdate:closingHour"]),
              _createVNode(_component_OpeningHoursSelect, {
                day: 'Thursday',
                openingHour: _ctx.newPlace.openingHour,
                "onUpdate:openingHour": [
                  _cache[19] || (_cache[19] = ($event: any) => (_ctx.newPlace.openingHour = $event)),
                  _ctx.updateOpeningHour
                ],
                closingHour: _ctx.newPlace.closingHour,
                "onUpdate:closingHour": [
                  _cache[20] || (_cache[20] = ($event: any) => (_ctx.newPlace.closingHour = $event)),
                  _ctx.updateClosingHour
                ]
              }, null, 8, ["openingHour", "closingHour", "onUpdate:openingHour", "onUpdate:closingHour"]),
              _createVNode(_component_OpeningHoursSelect, {
                day: 'Friday',
                openingHour: _ctx.newPlace.openingHour,
                "onUpdate:openingHour": [
                  _cache[21] || (_cache[21] = ($event: any) => (_ctx.newPlace.openingHour = $event)),
                  _ctx.updateOpeningHour
                ],
                closingHour: _ctx.newPlace.closingHour,
                "onUpdate:closingHour": [
                  _cache[22] || (_cache[22] = ($event: any) => (_ctx.newPlace.closingHour = $event)),
                  _ctx.updateClosingHour
                ]
              }, null, 8, ["openingHour", "closingHour", "onUpdate:openingHour", "onUpdate:closingHour"]),
              _createVNode(_component_OpeningHoursSelect, {
                day: 'Saturday',
                openingHour: _ctx.newPlace.openingHour,
                "onUpdate:openingHour": [
                  _cache[23] || (_cache[23] = ($event: any) => (_ctx.newPlace.openingHour = $event)),
                  _ctx.updateOpeningHour
                ],
                closingHour: _ctx.newPlace.closingHour,
                "onUpdate:closingHour": [
                  _cache[24] || (_cache[24] = ($event: any) => (_ctx.newPlace.closingHour = $event)),
                  _ctx.updateClosingHour
                ]
              }, null, 8, ["openingHour", "closingHour", "onUpdate:openingHour", "onUpdate:closingHour"]),
              _createVNode(_component_OpeningHoursSelect, {
                day: 'Sunday',
                openingHour: _ctx.newPlace.openingHour,
                "onUpdate:openingHour": [
                  _cache[25] || (_cache[25] = ($event: any) => (_ctx.newPlace.openingHour = $event)),
                  _ctx.updateOpeningHour
                ],
                closingHour: _ctx.newPlace.closingHour,
                "onUpdate:closingHour": [
                  _cache[26] || (_cache[26] = ($event: any) => (_ctx.newPlace.closingHour = $event)),
                  _ctx.updateClosingHour
                ]
              }, null, 8, ["openingHour", "closingHour", "onUpdate:openingHour", "onUpdate:closingHour"])
            ])
          ]),
          _createVNode("div", _hoisted_63, [
            _hoisted_64,
            _createVNode("div", _hoisted_65, [
              _createVNode("input", {
                type: "file",
                multiple: "",
                onChange: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.onFileChange && _ctx.onFileChange(...args)))
              }, null, 32)
            ])
          ]),
          _createVNode("a", {
            onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.addPlace && _ctx.addPlace(...args))),
            class: "button preview",
            style: {"margin-bottom":"30px"}
          }, [
            _hoisted_66,
            _hoisted_67
          ])
        ])
      ])
    ])
  ]))
})